<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="ticket_is_load" parent="ticket">
    <tab id="info" :name="translate('ticket.section.info')" :href="url+'/info'">
      <TicketInfo v-if="ticket_is_load"
        :ticket="ticket_info"
        @update="get_ticket"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Ticket: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/supports/'}">
              To Support list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import TicketInfo from './Tabs/Info/Info.vue'

export default {
  name: 'Ticket',
  components: {
    TicketInfo,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      ticket_info: null,
    }
  },

  computed: {
    url () { return '/ticket/' + this.$route.params.ticket_id },
    cur_id () { return this.$route.params.ticket_id },
    load () { return !this.ticket_info?.id },
    ticket_is_load() { return this.ticket_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'ticket_section') {
        this.get_ticket()
      }
    }
  },

  activated(){
    this.get_ticket()
  },

  methods: {
    get_ticket () {
      this.$http.v1.getTicketInfo(this.$route.params.ticket_id, (response) => {
        this.ticket_info = response.data
        this.$store.commit('updateSelectedTicket', response.data)
        this.$store.commit('updateOtherTitle', `${this.translate("ticket.one")} #${this.ticket_info.id}`)
      })
    }
  }
}

</script>
